import { render, staticRenderFns } from "./MediaPartnerList.vue?vue&type=template&id=133566c0"
import script from "./MediaPartnerList.vue?vue&type=script&lang=js"
export * from "./MediaPartnerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports